import type {
  UnitInfoDataInterface,
  UnitInfoDataReducerInterface,
} from './types';
import { UnitTypes } from '../../unitData/types';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const initialState: UnitInfoDataReducerInterface = {
  unitInfoData: {
    [UnitTypes.MOBILE_CONE_COMMON]: {},
    [UnitTypes.CONE_CRUSHER_CH]: {},
    [UnitTypes.CONE_CRUSHER_CS]: {},
    [UnitTypes.HYBRID_CRUSHER_CR]: {},
    [UnitTypes.FEEDER_AND_SCREEN]: {},
    [UnitTypes.PAN_FEEDER_SP]: {},
    [UnitTypes.PLATE_FEEDER_SH]: {},
    [UnitTypes.GRIZZLY_FEEDER_GENERAL]: {},
    [UnitTypes.FEED]: { predefinedMaterials: [], psdCurves: [] },
    [UnitTypes.FREEFALL_SCREEN_SF]: {},
    [UnitTypes.FREEFALL_SCREEN_SS]: {},
    [UnitTypes.GYRATORY_CRUSHER_CG]: {},
    [UnitTypes.IMPACT_CRUSHER_CI]: {},
    [UnitTypes.IMPACT_CRUSHER_CV]: {},
    [UnitTypes.BANANA_SCREEN]: {},
    [UnitTypes.SCHENCK_SCREEN]: {},
    [UnitTypes.KWATANI_SCREEN]: {},
    [UnitTypes.JAW_CRUSHER_CJ]: {},
    [UnitTypes.MOBILE_JAW_COMMON]: {},
    [UnitTypes.MOBILE_HSI_COMMON]: {},
    [UnitTypes.MOBILE_VSI]: {},
    [UnitTypes.MOBILE_SCREEN_COMMON]: {},
    [UnitTypes.MOBILE_JAW_AND_CONE]: {},
    [UnitTypes.BREAKER]: {
      booms: {},
      breakers: {},
    },
    SCREENING_MEDIA: {},
    [UnitTypes.GRIZZLY_SCREEN]: {
      models: {},
      configurations: {
        efficiency: {
          screeningMediaIds: [],
          efficiencyParameters: [],
          particleShapes: [],
        },
        normal: {
          overUnderSize: [],
          screeningMediaIds: [],
        },
        rockMaterials: [],
        allowedNumberOfDecks: [],
      },
    },
    [UnitTypes.CONVENTIONAL_SCREEN]: {},
    [UnitTypes.MULTISLOPE_SCREEN]: {},
  },
};

const unitInfoDataSlice = createSlice({
  name: 'unitInfoDataState',
  initialState,
  reducers: {
    getUnitInfoDataSuccess(
      state,
      action: PayloadAction<UnitInfoDataInterface>,
    ) {
      state.unitInfoData = action.payload;
    },
  },
});

export const { getUnitInfoDataSuccess } = unitInfoDataSlice.actions;

export const unitInfoDataReducer = unitInfoDataSlice.reducer;
